/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Response for GET /user/merge-status.
 *
 * Mirrors the fields the CHAI app needs from clinic's patient-keyed link status
 * (see clinic PatientLinkStatus). `status` is the lookup answer ("none" when the
 * user has never started a merge); `patient_facing_status` is what to show the
 * patient once a run exists.
 */
export interface MergeStatusResponse {
  /** Lookup status: "none" | "in_progress" | "completed" | "failed" */
  status: string;
  /** What to show the patient: "not_started" | "in_progress" | "merged" | "failed"; null when never linked */
  patient_facing_status?: string | null;
  /** The chart MRN, set once a relink completes; null otherwise */
  curai_patient_mrn?: string | null;
}
